import { mapState } from "vuex";
import { Button, Popconfirm, Switch } from "element-ui";
import ComplexTable from "@/shared/components/ComplexTable";
import CopyToClipboard from "@/shared/components/CopyToClipboard";
import AddShareLinkDrawer from "@/views/pages/SignalDetail/ShareLink/AddShareLinkDrawer";
import { fieldTypeMap } from "@/shared/components/SchemaForm";
import styles from "./index.less?module";

const ShareLink = {
  data() {
    return {
      invitationCode:"",
      userRemark:"",
      autoRecon:"",
      agreeActivation:""
    };
  },
  computed: {
    ...mapState(["checkPortfolio"]),
    statusTypeList() {
      return [
        { label: this.$t("Common_Yes"), value: true },
        { label: this.$t("Common_No"), value: false },
      ];
    },
  },
  created() {},
  methods: {
    getSearchFormDataSource() {
      return [
        // 邀请码
        {
          name: "invitationCode",
          label: this.$t("Invitation_Code"),
          fieldType: fieldTypeMap.textInput,
        },
        // 备注
        {
          name: "userRemark",
          label: this.$t("Remark"),
          fieldType: fieldTypeMap.textInput,
        },
        // 自动补单
        {
          name: "autoRecon",
          label: this.$t("Common_TableTitle_AutoMatchOrder"),
          fieldType: fieldTypeMap.select,
          fieldProps: {
            options: this.statusTypeList,
            clearable: true,
          },
        },
        // 激活状态
        {
          name: "agreeActivation",
          label: this.$t("Common_TableTitle_ActivationStatus"),
          fieldType: fieldTypeMap.select,
          fieldProps: {
            options: this.statusTypeList,
            clearable: true,
          },
        },
      ];
    },
    getTableData(params) {
      return this.$axios.post("/api/Portfolio/ShareLinkList", {
        portfolioId: this.checkPortfolio.id,
        ...params,
      });
    },
    reloadTable() {
      this.$refs.shareLinkTable.getList();
    },
    deleteShareLink(id) {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .delete(`/api/Portfolio/DeleteShareLink/${id}`)
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });
            this.reloadTable();
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    changeLinkStatus(id, inUse) {
      const loading = this.$loading({
        lock: true,
      });
      this.$axios
        .patch(`/api/Portfolio/EditLink/${id}`, {
          inUse: inUse ? 0 : 1,
        })
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });
            this.reloadTable();
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    handleAdd() {
      this.$refs.addShareLinkDrawer.open();
    },
  },

  render() {
    const searchFormDataSource = this.getSearchFormDataSource();
    const columns = [
      // 序号
      {
        prop: "sortNum",
        label: this.$t("Common_TableTitle_Number"),
        width: 80,
      },
      // 跟单比例
      {
        prop: "following",
        label: this.$t("Common_TableTitle_CopyRatio"),
        width: 150,
        scopedSlots: {
          default: ({ row: { following } }) => {
            return `${following} %`;
          },
        },
      },
      // 最大交易量
      {
        prop: "maxVolume",
        label: `${this.$t("Common_TableTitle_MaxLot")}(lots)`,
        width: 150,
         scopedSlots: {
          default: ({ row: { maxVolume } }) => {
            return maxVolume == 0 ? this.$t("Common_TR_VolumeNotLimit") : maxVolume;
          },
        },
      },
      // 交易对
      {
        prop: "forexSelect",
        label: this.$t("Common_TableTitle_Instruments"),
        width: 200,
        scopedSlots: {
          default: ({
            row: {
              forexSelect,
              metalsSelect,
              energySelect,
              indicesSelect,
              cryptoSelect,
            },
          }) => {
            return `${forexSelect ? this.$t("Common_Fx") : ""} ${
              energySelect ? this.$t("Common_Energy") : ""
            } ${metalsSelect ? this.$t("Common_Metal") : ""} ${
              indicesSelect ? this.$t("Common_Indices") : ""
            } ${cryptoSelect ? this.$t("Common_Crypto") : ""}`;
          },
        },
      },
      // 自动补单
      {
        prop: "autoRecon",
        label: this.$t("Common_TableTitle_AutoMatchOrder"),
        scopedSlots: {
          default: ({ row: { autoRecon } }) => {
            return autoRecon ? this.$t("Common_Yes") : this.$t("Common_No");
          },
        },
      },
      // 激活状态
      {
        prop: "agreeActivation",
        label: this.$t("Common_TableTitle_ActivationStatus"),
        scopedSlots: {
          default: ({ row: { agreeActivation } }) => {
            return agreeActivation
              ? this.$t("Common_Yes")
              : this.$t("Common_No");
          },
        },
      },
      // 邀请码
      {
        prop: "code",
        label: this.$t("Invitation_Code"),
        width: 180,
      },
      // 创建时间
      {
        prop: "createTime",
        label: this.$t("Common_TableTitle_CreateTime"),
        width: 130,
      },
      // 备注
      {
        prop: "remark",
        label: this.$t("Remark"),
        width: 200,
        scopedSlots: {
          default: ({ row: { remark } }) => {
            return remark ?? "-";
          },
        },
      },
      // 启用状态
      {
        prop: "inUse",
        label: this.$t("Enable_Status"),
        width: 180,
        scopedSlots: {
          default: ({ row: { inUse, id } }) => {
            return (
              <Switch
                ref={`switch${id}`}
                value={inUse}
                active-text={
                  inUse ? this.$t("Common_Enabled") : this.$t("Common_Disabled")
                }
                onChange={() => this.changeLinkStatus(id, inUse)}
              />
            );
          },
        },
      },
      // 操作
      {
        prop: "id",
        label: this.$t("Common_TableTitle_Operation"),
        width: 180,
        scopedSlots: {
          default: ({ row: { code, id, domain } }) => {
            return (
              <div class={styles.buttonGroup}>
                {/* 复制 */}
                <CopyToClipboard text={`${domain}ShareLinkDetail?code=${code}`}>
                  <Button class="cancelDialogBtn">{this.$t("Copy")}</Button>
                </CopyToClipboard>
                {/* 删除 */}
                <Popconfirm
                  title={this.$t("Confirm_Delete")}
                  onConfirm={() => this.deleteShareLink(id)}
                >
                  <Button slot="reference" class="cancelDialogBtn">
                    {this.$t("Common_Operation_Delete")}
                  </Button>
                </Popconfirm>
              </div>
            );
          },
        },
      },
    ];

    const toolBar = (
      <Button class="serchFormBtn" onClick={this.handleAdd}>
        {this.$t("Common_Operation_Add")}
        <i class="el-icon-plus el-icon--right"></i>
      </Button>
    );

    return (
      <div>
        <ComplexTable
          ref="shareLinkTable"
          schemaFormProps={{
            initialValues: {},
            dataSource: searchFormDataSource,
          }}
          columns={columns}
          requestApi={this.getTableData}
          toolBar={toolBar}
        />

        <AddShareLinkDrawer
          ref="addShareLinkDrawer"
          reloadTable={this.reloadTable}
        />
      </div>
    );
  },
};

export default ShareLink;
